/**
 * @generated SignedSource<<a9ac288a707ec4cb237b51281b197570>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EventDetailCancelWindowQuery$variables = {
  eventSignUpId: string;
};
export type EventDetailCancelWindowQuery$data = {
  readonly node: {
    readonly signUpWindow?: {
      readonly cancelDeadlineAt: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type EventDetailCancelWindowQuery = {
  response: EventDetailCancelWindowQuery$data;
  variables: EventDetailCancelWindowQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventSignUpId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "eventSignUpId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancelDeadlineAt",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventDetailCancelWindowQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventSignUpWindow",
                "kind": "LinkedField",
                "name": "signUpWindow",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "EventSignUp",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventDetailCancelWindowQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventSignUpWindow",
                "kind": "LinkedField",
                "name": "signUpWindow",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "EventSignUp",
            "abstractKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8c32d69a9b0665586e02d15dbd6ec706",
    "id": null,
    "metadata": {},
    "name": "EventDetailCancelWindowQuery",
    "operationKind": "query",
    "text": "query EventDetailCancelWindowQuery(\n  $eventSignUpId: ID!\n) {\n  node(id: $eventSignUpId) {\n    __typename\n    ... on EventSignUp {\n      signUpWindow {\n        cancelDeadlineAt\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "df590e7854baba694ca0522b252acbdb";

export default node;
